// extracted by mini-css-extract-plugin
module.exports = {"link":"DocumentFileLink_link__bf5Ec"};